/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamCorrectionDashboardQueryResponse,
  GetApiV1ExamCorrectionDashboardQueryParams,
  GetApiV1ExamCorrectionDashboard400,
  GetApiV1ExamCorrectionDashboard401,
  GetApiV1ExamCorrectionDashboard500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionDashboard.ts";

function getGetApiV1ExamCorrectionDashboardUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/exam/correction-dashboard` as const,
  };
  return res;
}

/**
 * @description Retorna os dados do painel de controle de correção. **(Requer Authorization para autenticação)**
 * @summary Painel de correção (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correction-dashboard}
 */
export async function getApiV1ExamCorrectionDashboard(
  params?: GetApiV1ExamCorrectionDashboardQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamCorrectionDashboardQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionDashboard400
      | GetApiV1ExamCorrectionDashboard401
      | GetApiV1ExamCorrectionDashboard500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamCorrectionDashboardUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
